import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Route, HashRouter as Router, Switch } from 'react-router-dom';
import { i18nIntl,isNotEmpty,migrate_question} from '../../lib/ep.js';
import { deburr as _deburr } from 'lodash';

import { alphabets as _alphabets } from '../games/WordSearchAlphabets';

import ActionButton, { MainButton, SecondaryButton } from '../builder/ActionButton.js';
import ActionLink from '../builder/ActionLink.js';
import BuilderCanvas from '../builder/BuilderCanvas.js';
import BuilderMain from '../builder/BuilderMain.js';
import BuilderSidebar from '../builder/BuilderSidebar.js';
import BuilderSubSectionTitle from './BuilderSubSectionTitle.js';
import ButtonCollection from '../builder/ButtonCollection.js';
import Checkbox from '../builder/Checkbox.js';
import ColorPicker from '../builder/ColorPicker.js';
import DisabledArea from '../builder/DisabledArea.js';
import FloatingLayer from '../builder/FloatingLayer.js';
import InputWithButton from '../builder/InputWithButton.js';
import Model from '../builder/Model.js';
import { NavigationTabsBuilder } from '../builder/NavigationTabs.js';
import Range from '../builder/Range.js';
import SectionTitle from '../builder/SectionTitle.js';
import Select from '../builder/Select.js';
import TextArea from '../builder/TextArea.js';
import Tooltip from '../builder/Tooltip.js';

import { GameContainerWrapper } from '../front/GameContainer.js';
import Layout from '../front/Layout.js';
import WordSearchClient from '../front/WordSearchClient.js';

import RibbonCollection from '../ui_items/RibbonCollection.js';
import CheckEnabler from '../builder/CheckEnabler.js';
import GameInstructionsBuilder from './GameInstructionsBuilder.js';
import GameScoreBuilder from './GameScoreBuilder.js';
import GameSoundtrackFields from '../builder/GameSoundtrackFields.js';

const GameSettings = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ wordsearch, setWordsearch ] = useState('');
	const [ errors_game, setErrorsGame ] = useState({});
	const [ display_custom_charset, setDisplayCustomCharset ] = useState(false);
	const [ display_chars_in_alphabet, setDisplayCharsInAlphabet ] = useState(false);

	const charset_preset = stage?.wordsearch_charset_preset ?? 'latin';
	const words = stage?.wordsearch_words ?? [];
	

	const getWordLength = (w) => {
		var w_test = w.toLowerCase().replace(" ", "");
		return unicodeLength(w_test);
	};
	
	const getMinSize = (initial = 5) => {
		let min_size = initial;
		words.map((w) => {
			min_size = Math.max(min_size, w.length);
		});
		return min_size;
	};

	let min_size_words = stage?.wordsearch_size ?? getMinSize();
	const replaceStr = (str, find, replace) => {
		for(let i = 0; i < find.length; i++) {
			str = str.replace(new RegExp(find[i], 'gi'), replace[i]);
		}
		return str;
	};

	const unicodeLength = (str, remove_chars) => {
		if(remove_chars != undefined) str = str.replace(remove_chars, "");
		return [...str].length;
	};

	const validate = (word) => {
		const word_test = word.toLowerCase().replace(" ", "");
		const word_length = unicodeLength(word_test);

		if(word_length > max_size_word) {
			return "This word is too long, maximum 20 characters";
		}

		if(word_length < min_size_word) {
			return "This word is too short, minimum 2 characters";
		}

		let error_msg = "";
		words.map((w) => {
			const w_test = w.toLowerCase().replace(" ", "");

			if(w_test != '' && (w_test.includes(word_test) || word_test.includes(w_test) || word_length > max_size_word || word_length < min_size_word)) {
				if(w_test.includes(word_test)) {
					error_msg = "This word is part of one of the existing words";
				} else if(word_test.includes(w_test)) {
					error_msg = "This word is included in one of the existing words";
				}
			}
		});

		if(error_msg != "") return error_msg;

		return true;
	};

	const createNewWord = (word) => {
		const words = stage?.wordsearch_words ?? [];
		word = (word == undefined || unicodeLength(word) == 0 || word == '') ? wordsearch : word;

		const letters_accepted_against_deburr = ['ç', 'ñ'];
		const letters_replaced_against_deburr = ['00cc00', '11nn11'];
		word = replaceStr(word, letters_accepted_against_deburr, letters_replaced_against_deburr);
		word = _deburr(word);
		word = replaceStr(word, letters_replaced_against_deburr, letters_accepted_against_deburr);

		if(words.length >= 15) return;
	
		const _errors_game = { ...errors_game };

		const valid = validate(word);

		if(valid !== true) {
			_errors_game.wordsearch = i18n(valid);
			setErrorsGame(_errors_game);
			return;
		}

		words.map((w) => {
			if(unicodeLength(w) > min_size_words) min_size_words = unicodeLength(w);
		});

		const _words = [ ...words ];
		_words.push(word);
		if(min_size_words < getWordLength(word) || isNaN(stage.wordsearch_size)) {
			change('wordsearch_size', Math.max(min_size_words, getWordLength(word)));
		}

		if(stage?.game_attempts != false) {
			if(stage?.game_attempts < _words.length) {
				change('game_attempts', _words.length);
			}
		}
	
		change('wordsearch_words', _words)

		setWordsearch('');
		setErrorsGame({});
	};

	const removeWord = (index) => {
		change('wordsearch_words', [ ...words ].filter((w) => (w != words[index])));
	};

	const openCharsInAlphabetLayer = () => {
		const charset = {
			default:_alphabets.find((obj) => (obj.id == charset_preset)).charset,
			custom:(isNotEmpty(stage, 'wordsearch_custom_charset')) ? stage.wordsearch_custom_charset.split(",") : [],
		};

		setDisplayCharsInAlphabet(charset);
	};

	const charset_presets = [];
	_alphabets.map((alphabet) => {
		if(alphabet.enabled != undefined && alphabet.enabled) {
			charset_presets.push({ k:alphabet.id, v:i18n(alphabet.label) });
		}
	});

	const max_words = 15;
	const min_chars = 2;
	const min_size_word = 2;
	const is_creating = false;
	const max_size_word = 20;
	const error_long_words = ((words.length + 1) >= parseInt(stage.wordsearch_size)) ? true : false;
	const disabled_area_active = (words.length >= max_words || error_long_words) ? true : false;

	const word_ribbons = [];
	words.map((word, w) => {
		word_ribbons.push({
			title:word.toUpperCase(),
			onDelete:() => removeWord(w),
			position:'top',
		});
	});

	const option_level = [
		{ k:'easy', v:`${i18n("Easy")} (→↓)` },
		{ k:'normal', v:`${i18n("Medium")} (→↓↗︎↘︎)` },
		{ k:'hard', v:`${i18n("***Hard")} (→↓↗︎↘︎←↑↙︎↖︎)` },
	];

	const min_attempts = words.length;
	const min_size = getMinSize();
	const max_size = 20;

	return (
		<>
			<BuilderSidebar
				onSave={props.saveStage}
				errors={(Object.keys(errors_game).length > 0) ? true : false}
			>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<article>
					<Model model={stage} change={change}>
						<Select
							_class={{ size:70, first:true }}
							name="wordsearch_level"
							values={option_level}
							label_props={{
								tooltip:<Tooltip
									autotranslate={false}
								>{`${i18n("Easy")}: ${i18n("Only vertical and horizontal dispositions")}<br />${i18n("Medium")}: ${i18n("Add diagonals to the previous level")}<br />${i18n("***Hard")}: ${i18n("Add reverse to the previous level")}`}</Tooltip>,
							}}
						>Level</Select>

						<Checkbox
							name="display_legend"
							value={stage?.display_legend ?? true}
						>Display legend</Checkbox>

						<Range
							min={30}
							max={300}
							step={5}
							label_props={{
								addition:"In seconds",
							}}
							name="game_time"
							value={Math.max((stage?.game_time ?? 60), 30)}
						>Time limit</Range>

						<CheckEnabler 
							label="Limit moves"
							enabled={stage?.game_attempts > 0}
							onDisable={() => change('game_attempts', "")}
							onEnable={() => change('game_attempts', min_attempts)}
						>
							<Range
								model={stage}
								change={change}
								min={min_attempts}
								max={50}
								step={1}
								name="game_attempts"
								value={Math.max((stage?.game_attempts ?? 1), min_attempts)}
							>Max. number of attempts/moves</Range>
						</CheckEnabler>

						<Checkbox
							name='silence'
						>Disable sounds</Checkbox>
					</Model>

					<GameSoundtrackFields
						stage={stage}
						change={change}
					/>
				</article>

				<article class='gui_not_in_top_huge'>
					<BuilderSubSectionTitle
						title="Game options"
						icon='knk-settings'
					/>

					<DisabledArea
						disabled={disabled_area_active}
						message={error_long_words ? "Increase the number of columns" : "Maximum of words reached"}
					>
						<InputWithButton
							label_props={{
								_class:(words.length < 1) ? { icon:'ep-exclamation orangeIcon gui_small_icon' } : null,
								_extra_component:<span><FormattedMessage id="Max. {max_words} words" values={{ max_words:max_words }} />] [<FormattedMessage id="Min. {min_chars} characters" values={{min_chars:min_chars}} /></span>,
							}}
							submitIcon='knk-add-item'
							submitColor={(wordsearch.length > min_chars && wordsearch != '') ? 'green' : 'gray'}
							errors={errors_game}
							name="wordsearch"
							placeholder={i18n("Type to add new words in game")}
							onSubmit={(v) => createNewWord(v)}
							onChange={(k, v) => setWordsearch(v)}
						>Words to search</InputWithButton>
					</DisabledArea>

					{(words.length > 0) && (
						<RibbonCollection
							_class={{ other:'gui_not_in_top_tiny'}}
							items={word_ribbons}
						/>
					)}

					<Model model={stage} change={change} errors={errors_game}>
						<Range
							min={min_size}
							max={max_size}
							step={1}
							default={5}
							name="wordsearch_size"
							value={Math.max(Math.min(parseInt(stage?.wordsearch_size ?? 5), max_size), min_size)}
						>Minimum number of columns</Range>

						<Select
							name="wordsearch_charset_preset"
							after_component={<span class="gui_flex_col gui_link_actions">{((!display_custom_charset) ? <ActionLink onClick={() => setDisplayCustomCharset(true)}>Add characters to the alphabet</ActionLink> : null)}<ActionLink onClick={openCharsInAlphabetLayer}>View included characters in the game</ActionLink></span>}
							values={charset_presets}
							_class={{ size:70 }}
						>Alphabet</Select>

						{(display_custom_charset) && (
							<TextArea
								name="wordsearch_custom_charset"
								label_props={{
									addition:"Comma separated",
								}}
							>Type the new characters</TextArea>
						)}
					</Model>
				</article>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout
					promo={props.promotion}
					is_builder={true}
					page="quiz"
					menus={props.promoModel.Custom__Menus}
					layout_extra_classes="is_new_game"
				>
					<div style={{width:'100%'}}>
						{(Object.keys(errors_game).length == 0) ? (
							<WordSearchClient
								stage={{ Stage:stage }}
								is_builder={true}
								is_playable={true}
								
								section="settings"
							/>
						) : (
							<GameContainerWrapper>
								<div class="is_fullscreen relative_to_container empty_game_warning not_awesome orangeBg knk-arrow-l-big">
									{Object.values(errors_game).map((error, i) => {
										if(typeof error === 'object') return null;

										return (
											<p key={`error${i}`}>{error}</p>
										)
									})}
								</div>
							</GameContainerWrapper>
						)}
					</div>
				</Layout>
			</BuilderCanvas>

			{(display_chars_in_alphabet !== false) && (
				<FloatingLayer
					backButton={() => setDisplayCharsInAlphabet(false)}
					_class={{ size:'small' }}
				>
					<div class="without_actions">
						<SectionTitle>Characters in game</SectionTitle>

						<div class="gui_icon_picker">
							<ul class="gui_padded_children_v">
								<li>
									<ButtonCollection
										type='ul'
										_class={{other:'gui_flex_wrap'}}
										style={{ fontSize:'1.5em' }}
									>
										{display_chars_in_alphabet.default.map((char, c) => {
											if(char == "") return null;

											return (
												<li key={`custom_${c}`}>
													<SecondaryButton
														squared={true}
														_class={{other:'gui_withoutEvents'}}
													>{char.toUpperCase()}</SecondaryButton>
												</li>
											)
										})}

										{display_chars_in_alphabet.custom.map((char, c) => {
											if(char == "") return null;

											return (
												<li key={`custom_${c}`}>
													<MainButton
														icon='mainButton'
														squared={true}
														_class={{other:'gui_withoutEvents'}}
													>{char.toUpperCase()}</MainButton>
												</li>
											)
										})}
									</ButtonCollection>
								</li>
							</ul>

							{(display_chars_in_alphabet.custom.length > 0) && (
								<div class="gui_not_in_top_big">
									<ul class="gui_flexbox gui_flex_space_between">
										<ButtonCollection type='li'>
											{i18n("Default character")}:&nbsp;
											<SecondaryButton
												squared={true}
												icon='knk-white-space'
												_class={{other:'gui_withoutEvents gui_not_in_start_small'}}
											/>
										</ButtonCollection>

										<ButtonCollection type='li'>
											{i18n("Custom character")}:&nbsp;

											<MainButton
												squared={true}
												icon='knk-white-space mainButton'
												_class={{other:'gui_withoutEvents gui_not_in_start_small'}}
											/>
										</ButtonCollection>
									</ul>
								</div>
							)}
						</div>
					</div>
				</FloatingLayer>
			)}
		</>
	)
};

const GameDesign = ({ stage, change, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	return (
		<>
			<BuilderSidebar
				onSave={props.saveStage}
			>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<article>
					<BuilderSubSectionTitle
						title="Board main colors"
						icon='knk-settings'
					/>

					<Model model={stage} change={change}>
						<ColorPicker
							name="text_color"
							color={stage?.text_color ?? 'rgba(0, 0, 0, 1)'}
							_class={{ size:50 }}
						>Letter color</ColorPicker>

						<ColorPicker
							name="wordsearch_selection_color"
							_class={{ size:50 }}
							color={stage?.wordsearch_selection_color ?? 'rgba(0, 0, 0, 0.3)'}
						>Selection color</ColorPicker>

						<ColorPicker
							name="bg_color"
							color={stage?.bg_color ?? 'rgba(255, 255, 255, 1)'}
							_class={{ size:50 }}
						>Background color</ColorPicker>

						<Checkbox
							name="display_outter_border"
							value={stage?.display_outter_border ?? true}
						>Display outer border</Checkbox>
					</Model>
				</article>

				<article class="gui_not_in_top_huge">
					<BuilderSubSectionTitle
						title="Found word colors"
						icon='knk-settings'
					/>

					<Model model={stage} change={change}>
						<ColorPicker
							name="highlight_text_color"
							_class={{ size:50 }}
							color={stage?.highlight_text_color ?? 'rgba(255, 255, 255, 1)'}
						>Letter color</ColorPicker>

						<ColorPicker
							name="highlight_color"
							_class={{ size:50 }}
							color={stage?.highlight_color ?? 'rgba(120, 195, 0, 1)'}
						>Background color</ColorPicker>

						<Range
							min={0}
							max={3}
							name="wordsearch_word_border_width"
							default={2}
							step={1}
							_class={{ size:50 }}
							value={stage?.wordsearch_word_border_width ?? 2}
							label_props={{
								_extra_component:i18n("in 'px'"),
							}}
						>Border width</Range>

						{(parseInt(stage?.wordsearch_word_border_width ?? 2) > 0) && (
							<ColorPicker
								name="wordsearch_word_border_color"
								_class={{ size:50 }}
								_hide_code={true}
								color={stage?.wordsearch_word_border_color ?? (stage?.text_color ?? 'rgba(0, 0, 0, 1)')}
							>Border color</ColorPicker>
						)}
					</Model>
				</article>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout
					promo={props.promotion}
					is_builder={true}
					page="quiz"
					menus={props.promoModel.Custom__Menus}
					layout_extra_classes="is_new_game"
				>
					<div style={{width:'100%'}}>
						<WordSearchClient
							stage={{ Stage:stage }}
							is_builder={true}
							is_playable={true}
							section="settings"
						/>
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

const GameTest = ({ stage, change, ...props }) => {
	const restart = () => {
		change('reset', (stage.reset != undefined) ? (stage.reset + 1) : 0);
	};

	return (
		<>
			<BuilderSidebar
				onSave={props.saveStage}
			>
				<NavigationTabsBuilder
					relative_selection={true}
					active={`${props.nav_active}`}
					sections={props?.nav_sections ?? []}
				>{props.stage_indicator}</NavigationTabsBuilder>

				<ButtonCollection>
					<ActionButton
						icon='knk-reload'
						onClick={() => restart()}
					>Restart game</ActionButton>
				</ButtonCollection>
			</BuilderSidebar>

			<BuilderCanvas fit_to_window="content">
				<Layout
					promo={props.promotion}
					is_builder={true}
					page="quiz"
					menus={props.promoModel.Custom__Menus}
					layout_extra_classes="is_new_game"
				>
					<div style={{width:'100%'}}>
						<WordSearchClient
							stage={{ Stage:stage }}
							is_builder={true}
							is_playable={true}
							is_test={true}
						/>
					</div>
				</Layout>
			</BuilderCanvas>
		</>
	)
};

const WordSearchBuilder = ({ base_route, stage, ...props }) => {
	const basename = `/stages/${stage.id}/wordsearch`;
	const nav_sections = [
		{ label:"Go back", link:`/stages/${stage.id}/options`, icon:'knk-go-prev' },
		{ label:"Gameplay settings", link:`${basename}/settings`, icon:'knk-settings' },
		{ label:"Design", link:`${basename}/design`, icon:'knk-artist-mode' },
		{ label:"Instructions", link:`${basename}/instructions`, icon:'knk-help' },
		{ label:"Score screen", link:`${basename}/gamescore`, icon:'knk-like' },
		{ label:"Test the game", link:`${basename}/test`, icon:'knk-ok' },
	];

	const migrate_from_question = true;
	if(migrate_from_question) {
		const question = props.questionStore.getState()?.questions.questions.find((q) => (q.Question.stage == stage.id));

		const game_stage_fields_map = {
			words:'wordsearch_words',
			size:'wordsearch_size',
			charset_preset:'wordsearch_charset_preset',
			custom_charset:'wordsearch_custom_charset',
			color_ok:'highlight_color',
			time_seconds:'game_time',
			attemps:'game_attemps',
			display_legend:'display_legend',
			level:'wordsearch_level',
			text_color:'text_color',
			bg_color:'bg_color',
			instructions_img:'instructions_img',
			full_instructions_img:'full_instructions_img',
		}

		if(question) {
			migrate_question(game_stage_fields_map, stage, question.Question);
		}
	};

	const common_props = {
		stage,
		is_multistage:props.is_multistage,
		isCorporate:props.isCorporate,
		change:props.change,
		changeMulti:props.changeMulti,
		intl:props.intl,
		promotion:props.promotion,
		promoModel:props.promoModel,
		saveStage:props.saveStage,
		stage_indicator:props.stage_indicator,
		nav_sections:nav_sections,
	};

	return (
		<BuilderMain pm={props.promoModel}>
			<Router basename={basename} hashType="noslash">
				<Switch>
					<Route exact={true} path="/settings">
						<GameSettings
							{...common_props}
							nav_active={`/settings`}
						/>
					</Route>

					<Route exact={true} path="/design">
						<GameDesign
							{...common_props}
							nav_active={`/design`}
						/>
					</Route>

					<Route exact={true} path="/instructions">
						<GameInstructionsBuilder
							{...common_props}
							nav_active={`/instructions`}
						>
							<WordSearchClient
								stage={{ Stage:stage }}
								promotion={props.promotion}
								is_builder={true}
								section="instructions"
							/>
						</GameInstructionsBuilder>
					</Route>

					<Route exact={true} path="/gamescore">
						<GameScoreBuilder
							{...common_props}
							nav_active={`/gamescore`}
							exclude_cases={['fail']}
						>
							<WordSearchClient
								stage={{ Stage:stage }}
								promotion={props.promotion}
								is_builder={true}
								section="score"
							/>
						</GameScoreBuilder>
					</Route>

					<Route exact={true} path="/test">
						<GameTest
							{...common_props}
							nav_active={`/test`}
						/>
					</Route>
				</Switch>
			</Router>
		</BuilderMain>
	)
}
export default injectIntl(WordSearchBuilder);